<template>
  <div>
    <!-- Settings Popup 设备详情弹窗 -->
    <div class="popup-wrap">
      <div class="popup-header text-center">
        Current Settings
      </div>


      <div class="hub-device-info-wrap  vertical justify-center">

        <div v-show="activeMode === 0" class="popup-content">

          <div class="horizontal items-center w-full ">
            <div class="vertical items-center justify-center " style="flex:1">
              <van-image :src="require('@/assets/icons/consumer/ic_default_hub.svg')" fit="contain" height="164"/>
            </div>

            <div class="flex-1 vertical" style="height:187px;">
              <div class="horizontal">
                <div class="vertical">
                  <span class="device-name">OMNI HUB</span>
                  <span class="device-id">{{ macAddressText }}</span>
                </div>
                <!--                <span v-if="isSupportLevel" style="border: 1px solid #000000;border-radius: 50%;height:25px;width:25px;display: flex;align-items: center;justify-content: center;font-size:18px;">{{level + 1}}</span>-->
              </div>
              <div class=" mt-4 vertical items-center justify-center flex-1">

                <div
                    id="hubCurve"
                    ref="hubCurve"
                    class="voltage-one"
                    style="width:100%;height:123px"></div>
              </div>
            </div>
          </div>


        </div>
        <div v-show="activeMode === 1" class="popup-content">

          <div class="horizontal items-center w-full" v-if="loadDeviceSettingStatus === 1">
            <div class="vertical items-center justify-center" style="flex:1">
              <van-image :src="insertDeviceName.image" fit="contain" height="164" show-loading>
                <template v-slot:loading>
                  <van-loading type="spinner" size="50"/>
                </template>
              </van-image>
            </div>

            <div class="flex-1 vertical" style="height:187px;font-size:14px">
              <div class="horizontal">
                <div class="vertical">
                  <span class="device-name">{{ insertDeviceName.name }}</span>
                  <span class="device-id">{{ deviceIdentify }}</span>
                </div>
                <span v-if="isSupportLevel" class="device-level">{{ level + 1 }}</span>
              </div>

              <div class=" vertical items-center justify-center flex-1">

                <div
                    id="deviceCurve"
                    ref="deviceCurve"
                    class="voltage-one"
                    style="width:100%;height:123px"
                />
              </div>
            </div>
          </div>
          <div v-else-if="loadDeviceSettingStatus === 0" class="vertical items-center">
            <van-image width="153" height="174" :src="require('@/assets/icons/v2/ic_hub_error.svg')"/>
            <div class="device-error-msg">{{ errorMessage }}</div>
          </div>
          <div v-else class="popup-content info-device-load">
            <van-loading size="60px"/>
          </div>

        </div>
      </div>
      <!--<div class="sync-button" @click="syncToApp">Close</div>-->
    </div>


    <div class="setting-model">
      <button
          class="model-button"
          :class="activeMode === 0 ? 'model-button-active' : ''"
          style="margin-right:8px;"
          @click="onClickSelectModel(0)"
      >
        Hub
      </button>
      <button
          class="model-button"
          :class="activeMode === 1 ? 'model-button-active' : ''"
          style="margin-left:8px;"
          @click="onClickSelectModel(1)"
      >
        Device
      </button>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { WriterSetting } from "@/bluetooth/BluetoothData";
import bluetoothRepository from "@/bluetooth/BluetoothRepository";
import { chartConfigBlue, d019ChartConfig } from "@/config/echarts-data";
import { calcMaxPower, calcVoltageFloorInt } from "@/util/utils";
import log from "@/util/log";
import HistoryCurve from "@/views/HistoryCurve.vue";

const graphic = require("echarts/lib/util/graphic");
export default {
  name: "CurrentSetting",
  components: { HistoryCurve },
  //components: { DeviceSetting, HubSetting },
  props: {
    rValue: {
      type: Number,
      default: 1.0
    },
    maxValue: {
      type: Number,
      default: 12
    }
  },
  data() {
    //黄 0
    //白 1
    return {
      powers: [1, 2, 3, 4, 5, 6, 7, 8],
      hubCurveChart: null,
      hubChartOption: chartConfigBlue(false),
      deviceCurveChart: null,
      deviceCurveOption: chartConfigBlue(false),
      activeMode: 0,
      showProgress: true,
      errorMessage: "",
      hubSetting: this.getHubSetting(),
      loadDeviceSettingStatus: 2,
      timeoutId: -1,
      curveLevelColor: ["green", "rgba(255, 140, 0, 1)", "red"],
      curveLevelColorLinearGradient: [
        ["rgba(0, 255, 0, 1)", "rgba(0, 255, 0, 0.2)"],
        ["rgba(255, 140, 0, 1)", "rgba(255, 140, 0, 0.2)"],
        ["rgba(255, 0, 0, 1)", "rgba(255, 0, 0, 0.2)"]
      ],
      curveColor: "#86A1A9",
      curveColorLinearGradient: [
        "rgba(192, 222, 226, 1)",
        "rgba(246, 250, 250, 1)"
      ],
      currentDeviceLevel: 0
    };
  },
  created() {
  },
  mounted() {
    //console.log("mounted");
    if (this.$refs.hubCurve) {
      this.hubCurveChart = this.$echarts.init(this.$refs.hubCurve);
      window.addEventListener("resize", this.onWindowSizeChanged);
    }
    this.refreshHubCurve();
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowSizeChanged);
  },
  computed: {
    ...mapState(["disposableHubSetting"]),
    ...mapState("bluetooth", [
      "isConnected",
      "macAddress",
      "cartridgeFlag",
      "deviceId",
      "writerSetting",
      "level",
      "insertDeviceName"
    ]),
    ...mapState("theme", ["syncButtonColor"]),

    levelClasses() {
      let background = "";
      log(`读取的档位 = ${this.level}`);
      if (this.level === 0) {
        background = "yellow";
      } else if (this.level === 1) {
        background = "white";
      }
      return {
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        "margin-left": "10px",
        border: "1px #999 solid",
        background
      };
    },
    macAddressText() {
      return (this.macAddress && this.macAddress.replace(/:/g, "")) || "";
    },
    deviceType() {
      if (this.deviceId) {
        switch (this.deviceId.type) {
          case 1:
            return "Disposable";
          case 3:
            return "Pod Battery";
          case 5:
            return "510 Battery";
        }

        return "";
      }
      return "";
    },
    isD019() {
      if (this.isConnected) {
        if (this.deviceId) {
          const insertDeviceName = this.insertDeviceName.name;
          if (
              insertDeviceName === "PORTO" ||
              insertDeviceName === "D022" ||
              insertDeviceName === "D023"
          ) {
            return true;
          }
        }
      }
      return false;
    },

    isSupportLevel() {
      if (this.isConnected) {
        if (this.deviceId) {
          const insertDeviceName = this.insertDeviceName.name;
          if (
              insertDeviceName === "510 Pen" ||
              insertDeviceName === "Lipstick" ||
              insertDeviceName === "PORTO"
          ) {
            return true;
          }
        }
      }
      return false;
    },
    brandName() {
      if (this.deviceId) {
        switch (this.deviceId.productManufacture) {
          case 0:
            return "AVD";
          case 1:
            return "iKrusher";
          case 2:
            return "Unicore";
        }
      }
      return "";
    },

    deviceIdentify() {
      if (this.deviceId) {
        return this.deviceId.deviceNumberHex//.replace(/:/g, '') || '';
      }
      return "";
    },
    resistance() {
      if (this.deviceId) {
        const r = this.deviceId.atomizedR;
        if (this.getInsertDeviceName() == "NORD") {
          return "1.2";
        }
        return `${(r / 10).toFixed(1)}`;
      }
      return "";
    },
    productTime() {
      if (this.deviceId) {
        const year = this.deviceId.productYear;
        const week = this.deviceId.productWeek;

        return `week ${week.toString(16)}, 20${year.toString(16)}`;
      }
      return "";
    }
  },
  watch: {
    // async activeMode(newValue, oldValue) {
    //   if (newValue === 1) {
    //     this.reloadDeviceSetting();
    //   } else {
    //     this.showProgress = true;
    //     store.commit(StoreType.COMMIT_TYPE.STATE_CURRENT_WRITER_SETTING, null);
    //   }
    // }
    deviceId(value) {
      if (value) {
        if (value.type === 5) {
          //电池修改颜色
          const level = ((value.productManufacture >> 4) & 0x0f) - 1;
          if (level < 3) {
            this.curveColor = this.curveLevelColor[level];
            this.curveColorLinearGradient = this.curveLevelColorLinearGradient[
                level
                ];
            this.currentDeviceLevel = level;
            return;
          }
        }
      } //为空了
      this.curveColor = this.defaultCurveColor; //默认颜色
      this.curveColorLinearGradient = [
        this.defaultCurveLineColor[0],
        this.defaultCurveLineColor[1]
      ]; //默认渐变颜色
    }
  },
  methods: {
    ...mapGetters("bluetooth", ["getHubSetting"]),
    ...mapState("bluetooth", ["insertDeviceName"]),
    ...mapState("theme", {
      defaultCurveColor: state => state.curveColor,
      defaultCurveLineColor: state => state.curveLineColor
    }),
    onApplyToHome() {
      const writerSetting = new WriterSetting();
      Object.assign(writerSetting, this.writerSetting);
      writerSetting.diyVoltage = writerSetting.diyVoltage.slice(0, 8);
      this.$emit("onApplyToHome", writerSetting);
    },
    async onClickSelectModel(value) {
      this.activeMode = value;
      if (value === 1) {
        //如果是device的时候，转圈加载完在显示
        this.reloadDeviceSetting();
      }
    },

    onClickClose() {
      this.$emit("close");
      this.$nextTick(() => {
        setTimeout(() => {
          this.activeMode = 0;
        }, 100);
      });
    },

    //刷新echarts
    refreshHubCurve() {
      this.hubSetting.power = this.hubSetting.diyVoltage.map(
          item => Math.pow(item, 2) / 1000000 / parseFloat(this.rValue)
      );
      this.preheatPower = parseInt(
          Math.pow(this.hubSetting.preheatVoltage, 2) /
          1000000 /
          parseFloat(this.rValue)
      );


      const limitMaxVoltage = calcVoltageFloorInt(this.maxValue, this.rValue);
      const maxPower = calcMaxPower(limitMaxVoltage, this.rValue);

      const max = this.hubSetting.power.reduce((a, b) => Math.max(a, b));
      this.hubChartOption.yAxis.max = maxPower;
      this.hubChartOption.series[0].data = this.hubSetting.power;
      this.hubCurveChart.setOption(this.hubChartOption, true);
    },

    refreshDeviceCurve() {
      if (this.$refs.deviceCurve) {
        this.deviceCurveChart = this.$echarts.init(this.$refs.deviceCurve);
      }

      const limitMaxVoltage = calcVoltageFloorInt(this.maxValue, this.rValue);
      const maxPower = calcMaxPower(limitMaxVoltage, this.rValue);
      if (this.insertDeviceName.name === "PORTO" && this.deviceId.productWeek === 82
          && this.deviceId.productYear === 35
          && this.level === 1) {
        //判断是否d019是烧录错的
        const errorVoltages = [3200, 3100, 2900, 2800, 2700, 2600, 2500, 2400, 2400, 2400];
        if (this.writerSetting.diyVoltage.toString() === errorVoltages.toString()) {
          this.writerSetting.diyVoltage = [3200, 3100, 3000, 2900, 2800, 2700, 2600, 2400, 2400, 2400];
        }
      }
      //

      this.writerSetting.power = this.writerSetting.diyVoltage.map(
          item => {
            const power = Math.pow(item, 2) / 1000000 / parseFloat(this.rValue);
            return power >= maxPower ? maxPower : power;
          }
      );
      this.preheatPower = parseInt(
          Math.pow(this.writerSetting.preheatVoltage, 2) /
          1000000 /
          parseFloat(this.rValue)
      );

      const deviceId = this.deviceId;
      if (deviceId) {
        if (deviceId.type === 5) {
          //电池修改颜色
          const level = ((deviceId.productManufacture >> 4) & 0x0f) - 1;
          if (level < 3) {
            this.curveColor = this.curveLevelColor[level];
            this.curveColorLinearGradient = this.curveLevelColorLinearGradient[
                level
                ];
            this.currentDeviceLevel = level;
          }
        } else {
          this.curveColor = this.defaultCurveColor; //默认颜色
          this.curveColorLinearGradient = [
            this.defaultCurveLineColor[0],
            this.defaultCurveLineColor[1]
          ]; //默认渐变颜色
        }

        let options = chartConfigBlue(false);
        if (this.isD019) {
          const level = this.level;
          // console.log(`当前d019的档位 => ${level}`)
          // options = d019ChartConfig(this.isD019 ? "D019" : "", level + 1, false);
        }

        const max = this.writerSetting.power.reduce((a, b) => Math.max(a, b));

        options.yAxis.max = Math.max(this.maxValue, max);
        options.series[0].data = this.writerSetting.power;//.map((item,index) => [index+1, parseFloat(item.toFixed(1))]);

        this.deviceCurveChart.setOption(options, true);
      }
    },

    async resetToHubSetting() {
      this.$emit("resetToHubSetting");
    },

    async reloadDeviceSetting() {
      //如果是device的时候，转圈加载完在显示
      try {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
          this.errorMessage = "Timeout";
          this.loadDeviceSettingStatus = 0;
        }, 5000);
        this.loadDeviceSettingStatus = 2; //转圈加载

        await bluetoothRepository.queryWriter();
        clearTimeout(this.timeoutId);
        this.loadDeviceSettingStatus = 1; //加载成功

        this.$nextTick(() => {
          this.refreshDeviceCurve();
        });
      } catch (e) {
        clearTimeout(this.timeoutId);

        // console.log(e)
        if (typeof e === "string") {
          this.errorMessage = e;
        } else {
          this.errorMessage = "Read device info failure!";
        }
        this.loadDeviceSettingStatus = 0; //加载失败
      }
    },

    onWindowSizeChanged() {
      if (this.$refs.hubCurve) {
        this.$nextTick(() => {
          this.hubCurveChart.resize();
        });
      }
      if (this.$refs.deviceCurve) {
        this.$nextTick(() => {
          this.deviceCurveChart.resize();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-tabs__wrap {
  height: 1.6rem;
  margin-bottom: 20px;
}

/deep/ .van-tabs__nav--card {
  height: 1.6rem;
  border: none;
  background: transparent !important;
}

/deep/ .van-tab {
  margin: 0 5px !important;
  color: #939598;
  background: #e8eff2;
  border-right: none !important;
  border-bottom: none !important;
  border-radius: 5px !important;

  span {
    font-size: 18px;
  }
}

/deep/ .van-tab--active {
  background: #86a1a9 !important;
}

.hub-device-info-wrap {
  height: 187px;
  margin-top: 58px;
}

.popup-wrap {
  position: relative;
  overflow: hidden;
  font-family: 'outfit';
  padding: 16px;
  font-size: 18px;
}


.setting-model {
  display: flex;
  align-items: center;
  margin-top: 24px;


  .model-button {
    height: 55px;
    border-radius: 13px;
    margin: 0 20px;
    background: white;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border: 1px solid #C1C1C1;
    flex: 1
  }

  .model-button-active {
    flex: 1;
    border-radius: 13px;
    background: #333333;
    color: #ffffff;
  }
}

.device-name {
  font-weight: 500;
  font-size: 18px;
}

.device-id {
  font-family: 'outfit-thin';
  font-weight: normal;
  font-size: 14px;
}

.info-device-load {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 60px 0;
}

.device-error-msg {
  font-family: 'outfit-thin';
  text-align: center;
}


// iPhone13
@media only screen and (min-device-width: 390px)  and (-webkit-device-pixel-ratio: 3) {
  .device-name {
    font-weight: 500;
    font-size: 15px;
  }

  .device-id {
    font-family: 'outfit-thin';
    font-weight: normal;
    font-size: 12px;
  }
}

.device-level {
  border: 1px solid #000000;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
</style>
